export default __webpack_public_path__ + "static/ECI_logo_uppercase-77d891a085aafc1f16fa1d42e9ec9a55.svg";